import { Component, inject } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { finalize } from "rxjs";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { getQueryParamAsConst } from "../../../utils/utils";
import { AuthService } from "../../services/auth.service";
import { CollaboratorsService } from "../../services/collaborators.service";

@Component({
  selector: "app-collaborators-acceptance",
  imports: [ButtonComponent, AppLayoutComponent, RouterModule],
  templateUrl: "./collaborators-acceptance.component.html",
  styleUrl: "./collaborators-acceptance.component.scss",
})
export class CollaboratorsAcceptanceComponent {
  private readonly _collaboratorsService = inject(CollaboratorsService);
  private readonly _router = inject(Router);
  private readonly _authService = inject(AuthService);

  loading = false;

  token = getQueryParamAsConst("token");
  async acceptInvitation() {
    const isAuthenticated = await this._authService.isAuthenticated();

    if (!isAuthenticated) {
      alert("Faça login primeiro");
    } else if (this.token) {
      this.loading = true;
      this._collaboratorsService
        .acceptInvitation(this.token)
        .pipe(finalize(() => (this.loading = false)))
        .subscribe(() => this._router.navigate([""]));
    }
  }
}
